import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

export default function HeadingSmall({ children, className }) {
  return (
    <h1
      className={className}
      css={styles.heading}
    >
      {children}
    </h1>
  );
}

HeadingSmall.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

const styles = StyleSheet.create({
  heading: {
    ...Theme.heading2(),
    marginBottom: 15,
  },
});
